import React, { useEffect, useState } from 'react';
import { Layout, Menu, Avatar, Dropdown, message } from 'antd'; 
import './App.css';
import { Navigate, Route, Routes, useNavigate, useLocation } from 'react-router-dom'; 
import { globalStore } from './models/globalStore';
import UserProfileModal from './components/PersonalProfile/UserProfileModal';
import { observer } from 'mobx-react-lite'; 
import EasyInput from './components/EasyInput/EasyInput'; 
import {
  DashboardOutlined,
  ShopOutlined,
  UserOutlined,
  ShoppingOutlined,
  OrderedListOutlined,
  FileTextOutlined,
  DollarOutlined,
  MessageOutlined,
  FlagOutlined,
  AuditOutlined,
  FileOutlined,
  LogoutOutlined,
  SettingOutlined,
  MenuFoldOutlined, 
  BankOutlined,
  IdcardOutlined,
  SolutionOutlined,
  ToolOutlined
} from '@ant-design/icons';

// 导入所有页面组件
import Dashboard from './views/pages/Dashboard';
import SellerManagement from './views/pages/SellerManagement';
import BuyerManagement from './views/pages/BuyerManagement';
import ProductManagement from './views/pages/ProductManagement';
import OrderManagement from './views/pages/OrderManagement';
import InvoiceManagement from './views/pages/InvoiceManagement';
import CommissionManagement from './views/pages/CommissionManagement';
import ChatManagement from './views/pages/ChatManagement';
import ReportManagement from './views/pages/ReportManagement';
import ApprovalManagement from './views/pages/ApprovalManagement';
import ResumeManagement from './views/pages/ResumeManagement';
import EnterpriseAudit from './views/pages/EnterpriseAudit';
import IdentityAudit from './views/pages/IdentityAudit';
import ProductAudit from './views/pages/ProductAudit';
import SignatureAudit from './views/pages/SignatureAudit';
import CategoryManagement from './views/pages/CategoryManagement';
import EnterpriseAccountManagement from './views/pages/EnterpriseAccountManagement';
import AppConfigManagement from './views/pages/AppConfigManagement';
import SuperThemProcessManagement from './views/pages/SuperThemProcessManagement';
import JobManagement from './views/pages/JobManagement';
import TechnicalSupportManagement from './views/pages/TechnicalSupportManagement';

const { Header, Content, Sider } = Layout;

const menuItems = [
  { 
    key: 'dashboard', 
    icon: <DashboardOutlined />, 
    label: '仪表盘',
    path: '/dashboard'
  },
  {
    key: 'trade',
    icon: <ShoppingOutlined />,
    label: '买卖管理',
    children: [
      { 
        key: 'seller-management', 
        icon: <ShopOutlined />, 
        label: '卖家管理',
        path: '/seller-management'
      },
      { 
        key: 'buyer-management', 
        icon: <UserOutlined />, 
        label: '买家管理',
        path: '/buyer-management'
      },
      { 
        key: 'category-management', 
        icon: <OrderedListOutlined />, 
        label: '分类管理',
        path: '/category-management'
      },
      { 
        key: 'product-management', 
        icon: <ShoppingOutlined />, 
        label: '商品管理',
        path: '/product-management'
      },
      { 
        key: 'order-management', 
        icon: <OrderedListOutlined />, 
        label: '订单管理',
        path: '/order-management'
      },
    ]
  },
  {
    key: 'audit',
    icon: <AuditOutlined />,
    label: '审核管理',
    children: [
      { 
        key: 'product-audit', 
        icon: <ShoppingOutlined />, 
        label: '商品审核',
        path: '/product-audit'
      },
      { 
        key: 'approval-management', 
        icon: <AuditOutlined />, 
        label: '入驻审核',
        path: '/approval-management'
      },
      { 
        key: 'enterprise-audit', 
        icon: <BankOutlined />, 
        label: '企业审核',
        path: '/enterprise-audit'
      },
      { 
        key: 'identity-audit', 
        icon: <IdcardOutlined />, 
        label: '实名审核',
        path: '/identity-audit'
      },
      { 
        key: 'signature-audit', 
        icon: <IdcardOutlined />, 
        label: '签名审核',
        path: '/signature-audit'
      },
    ]
  },
  { 
    key: 'job-management', 
    icon: <SolutionOutlined />, 
    label: '岗位管理',
    path: '/job-management'
  },
  { 
    key: 'resume-management', 
    icon: <FileOutlined />, 
    label: '简历管理',
    path: '/resume-management'
  },
  {
    key: 'finance',
    icon: <DollarOutlined />,
    label: '财务管理',
    children: [
      { 
        key: 'invoice-management', 
        icon: <FileTextOutlined />, 
        label: '发票管理',
        path: '/invoice-management'
      },
      { 
        key: 'commission-management', 
        icon: <DollarOutlined />, 
        label: '发佣管理',
        path: '/commission-management'
      },
      { 
        key: 'enterprise-account-management', 
        icon: <BankOutlined />, 
        label: '企业账户',
        path: '/enterprise-account-management'
      },
    ]
  },
  {
    key: 'platform',
    icon: <FlagOutlined />,
    label: '平台管理',
    children: [
      { 
        key: 'chat-management', 
        icon: <MessageOutlined />, 
        label: '对话管理',
        path: '/chat-management'
      },
      { 
        key: 'config-management', 
        icon: <SettingOutlined />, 
        label: '配置管理',
        path: '/config-management'
      },
      { 
        key: 'super-them-process', 
        icon: <SettingOutlined />, 
        label: '入驻配置',
        path: '/super-them-process'
      },
      { 
        key: 'report-management', 
        icon: <FlagOutlined />, 
        label: '举报管理',
        path: '/report-management'
      },
      { 
        key: 'technical-support', 
        icon: <ToolOutlined />, 
        label: '技术支持',
        path: '/technical-support'
      },
    ]
  },
];

interface AppProps {
  onLoad?: () => void;
}

const App: React.FC<AppProps> = observer(({ onLoad })=>{
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [loginPhoneNo, setLoginPhoneNo] = useState<string>("");
  const [loginPassword, setLoginPassword] = useState<string>("");

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    onLoad?.();
  }, [onLoad]);

  useEffect(() => {
    globalStore.init();
  }, []);

  // 添加路由监听
  useEffect(() => {
    const currentPath = location.pathname;
    const menuItem = menuItems.find(item => item.path === currentPath);
    if (menuItem) {
      globalStore.selectedMenuKey = menuItem.key;
    }
  }, [location.pathname]);

  const handleLogin = async () => {
    if(!loginPhoneNo){
      message.error("登录手机号账号不为空");
      return;
    }
    if(!loginPassword){
      message.error("登录密码不为空");
      return;
    }
    await globalStore.login(loginPhoneNo, loginPassword);
  };

  const handleMenuClick = (info: any) => {
    const selectedItem = findMenuItem(menuItems, info.key);
    if (selectedItem && selectedItem.path) {
      globalStore.selectedMenuKey = info.key;
      navigate(selectedItem.path);
    }
  };

  // 递归查找菜单项
  const findMenuItem = (items: any[], key: string): any => {
    for (const item of items) {
      if (item.key === key) {
        return item;
      }
      if (item.children) {
        const found = findMenuItem(item.children, key);
        if (found) {
          return found;
        }
      }
    }
    return null;
  };

  const handleNicknameClick = () => {
    setIsModalVisible(true);
  };

  const logout = () => {
    globalStore.logout();
  };

  const userMenu = {
    items: [
      {
        key: 'profile',
        label: '个人资料',
        icon: <SettingOutlined />,
        onClick: handleNicknameClick,
      },
      {
        key: 'logout',
        label: '退出登录',
        icon: <LogoutOutlined />,
        onClick: logout,
      },
    ],
  };

  if (!globalStore.isLoggedIn) {
    return (
      <div className="login-page">
        <div className="login-container">
          <div className="login-header">
            <img src="/logo.png" alt="Logo" className="login-logo" />
            <h1>圆领管理后台</h1> 
          </div>
          <div className='login-form'>
            <EasyInput 
              label='请输入手机号'
              type={5}
              onChange={(v)=>{setLoginPhoneNo(v)}}
              value={loginPhoneNo}
              height='50px'
            />
            <EasyInput 
              label='请输入密码'
              type={4}
              onChange={(v)=>{setLoginPassword(v)}}
              value={loginPassword}
              height='50px'
            />
            <button className="login-button" onClick={handleLogin}>
              登录
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider 
        width={180}
        collapsible 
        collapsed={collapsed} 
        onCollapse={(value) => setCollapsed(value)}
        className="app-sider"
      >
        <div className={`logo-container ${collapsed ? 'collapsed' : ''}`} onClick={() => collapsed && setCollapsed(false)}>
          <img src="/logo.png" alt="Logo" className="sider-logo" />
          {!collapsed && (
            <>
              <span className="logo-text">圆领管理后台</span>
              <div className="menu-fold-icon" onClick={(e) => {
                e.stopPropagation();
                setCollapsed(true);
              }}>
                <MenuFoldOutlined />
              </div>
            </>
          )}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[globalStore.selectedMenuKey as string]}
          defaultOpenKeys={[]} // 默认全部折叠
          items={menuItems}
          onClick={handleMenuClick}
        />
      </Sider>
      <Layout>
        <Header className="app-header">
          <div className="header-content">
            <div className="breadcrumb">
              {findMenuItem(menuItems, globalStore.selectedMenuKey)?.label || '仪表盘'}
            </div>
            <Dropdown menu={userMenu} trigger={['click']}>
              <div className="user-info">
                <Avatar icon={<UserOutlined />} />
                <span className="user-name">{globalStore.currentUser?.nickname}</span>
              </div>
            </Dropdown>
          </div>
        </Header>
        <Content className="app-content">
          <div className="content-container">
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/seller-management" element={<SellerManagement />} />
              <Route path="/buyer-management" element={<BuyerManagement />} />
              <Route path="/product-management" element={<ProductManagement />} />
              <Route path="/order-management" element={<OrderManagement />} />
              <Route path="/invoice-management" element={<InvoiceManagement />} />
              <Route path="/commission-management" element={<CommissionManagement />} />
              <Route path="/chat-management" element={<ChatManagement />} />
              <Route path="/report-management" element={<ReportManagement />} />
              <Route path="/approval-management" element={<ApprovalManagement />} />
              <Route path="/job-management" element={<JobManagement />} />
              <Route path="/resume-management" element={<ResumeManagement />} />
              <Route path="/enterprise-audit" element={<EnterpriseAudit />} />
              <Route path="/identity-audit" element={<IdentityAudit />} />
              <Route path="/product-audit" element={<ProductAudit />} />
              <Route path="/signature-audit" element={<SignatureAudit />} />
              <Route path="/category-management" element={<CategoryManagement />} />
              <Route path="/enterprise-account-management" element={<EnterpriseAccountManagement />} />
              <Route path="/config-management" element={<AppConfigManagement />} />
              <Route path="/super-them-process" element={<SuperThemProcessManagement />} />
              <Route path="/technical-support" element={<TechnicalSupportManagement />} />
            </Routes>
          </div>
        </Content>
      </Layout>
      <UserProfileModal 
        isModalVisible={isModalVisible} 
        close={() => setIsModalVisible(false)} 
      />
    </Layout>
  );
});

export default App;